import React, { useEffect, useState } from 'react';
import { Text } from "components";
import Select from "react-select";
import axios from "axios";
import { TbCoinRupeeFilled } from "react-icons/tb";
import { FaBagShopping } from "react-icons/fa6";
import { BsPeopleFill } from "react-icons/bs";

import {
    Bar,
    BarChart,
    CartesianGrid,
    Legend,
    Rectangle,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from "recharts";

export default function Dashboardtest(props) {

    // Get today's date
    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0]; // Format as YYYY-MM-DD

    // Get the date 30 days ago
    const thirtyDaysAgo = new Date(today);
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    const formattedThirtyDaysAgo = thirtyDaysAgo.toISOString().split('T')[0]; // Format as YYYY-MM-DD

    const [companyPurchase, setCompanyPurchase] = useState([]);
    const [companyPurchesOrderCode, setCompanyPurchesOrderCode] = useState();

    const [toDate, setToDate] = useState(formattedToday);
    const [fromDate, setFromDate] = useState(formattedThirtyDaysAgo);
    const [showChart, setShowChart] = useState(false);
    const [flag, setFlag] = useState(false)

    const token = sessionStorage.getItem("token");
    const headers = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    useEffect(() => {
        companyPurchaseGet();
    }, [fromDate, toDate]);

    const obj = {
        from_date: fromDate,
        to_date: toDate
    };

    const companyPurchaseGet = () => {
        axios
            .post("/api/purple-fusion/CompanyPurchesOrder/get/CodeForReport", obj, headers)
            .then((response) => {
                setCompanyPurchase(response.data);
                // console.log(response.data)
                if (response.data.length > 0) {
                    setShowChart(true)
                }

            })
            .catch((err) => {
                console.log(err);
            });
    };

    // Custom tooltip component
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip" style={{ backgroundColor: 'white', padding: '5px', border: '1px solid #ccc' }}>
                    {flag == false && <p>{`PO Code:${payload[0].payload.code}`}</p>}
                    <p>{`Item: ${label}`}</p>
                    <p>{`Total Quantity: ${payload[0].value}`}</p>
                    <p>{`Received Quntity: ${payload[1].value}`}</p>
                    {/* Additional tooltip displaying delivery date */}
                    <p>{`Supplier Name: ${payload[0].payload.suppliername}`}</p>

                </div>
            );
        }
        return null;
    };

    const filteredPurchase = companyPurchase.filter((purchase) => {
        return purchase.code === companyPurchesOrderCode;
    });
    // console.log(filteredPurchase);
    // const id = filteredPurchase.length > 0 ? filteredPurchase[0].id : null;


    return (
        <>
            <div className='w-full flex flex-col'>

                <div className="flex flex-row mt-3 items-end justify-end mr-10 ">
                    <input
                        name="from_date"
                        type="date"
                        value={fromDate}
                        onChange={(e) => {
                            setFromDate(e.target.value);
                        }}
                        className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] pt-4 "
                    />
                    <Text className="text-sm md:text-[22px] text-gray-600  sm:text-xl pt-2 mr-2 ml-2 mb-2 ">
                        To
                    </Text>

                    <input
                        name="to_date"
                        type="date"
                        value={toDate}
                        onChange={(e) => {
                            setToDate(e.target.value);
                        }}
                        className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] pt-4"
                    />

                    <Select
                        options={[
                            { label: "Supplier All PO", value: "all" },

                            ...Array.from(new Set(companyPurchase.map((purchase) => purchase.code))).map(code => ({
                                label: code,
                                value: code,
                            }))
                        ]}
                        className="bg-white-A700 border border-gray-200_02 border-solid h-9 ml-2 rounded-md w-[25%]"
                        onChange={(selectedOption) => {
                            if (selectedOption.value == "all") {
                                setFlag(false)
                            }
                            else {
                                setFlag(true)
                            }
                            setCompanyPurchesOrderCode(selectedOption.value);
                            setShowChart(true);
                            // setFlag(true)
                        }}
                        placeholder="Select Code"
                    />
                </div>

                {showChart && (
                    <div className="w-[96%] h-full flex-col mt-2 ml-2 p-4 overflow-scroll border-2 shadow-xl">
                        <ResponsiveContainer width="100%" height={320}>
                            <BarChart
                                data={flag == false ? companyPurchase : filteredPurchase}
                                margin={{
                                    top: 50,
                                    right: 30,
                                    left: 20,
                                    bottom: 5,
                                }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="item_name" />
                                <YAxis />
                                <Tooltip content={<CustomTooltip />} />
                                <Legend />
                                <Bar
                                    dataKey="quantity"
                                    name="Total Quantity"
                                    fill="#8884d8"
                                    activeBar={<Rectangle fill="pink" stroke="blue" />}
                                />
                                <Bar
                                    dataKey="quantityforstockalloteditems"
                                    name="Received Quantity"
                                    fill="#82ca9d"
                                    activeBar={<Rectangle fill="gold" stroke="purple" />}
                                />
                            </BarChart>
                        </ResponsiveContainer>
                        {flag == true && (
                            <div className="flex flex-row justify-center items-center mt-3">
                                <h1 className="font-bold">Supplier Name:</h1>
                                <h1>{filteredPurchase[0]?.suppliername}</h1>
                            </div>
                        )}
                    </div>

                )}



            </div>
        </>
    );
}
